import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/services/authService';
import { checkSellerByUserId } from '../../auth/services/firestoreService';
import { checkIsAdmin } from '../services/adminService';
import Loader from '../../components/Loader';
import toast from 'react-hot-toast';

const AdminRoute = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const location = useLocation();
  const [isAdmin, setIsAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const verifyAdminStatus = async () => {
      if (!user) {
        if (isMounted) {
          setIsAdmin(false);
          setChecking(false);
        }
        return;
      }

      try {
        const { seller } = await checkSellerByUserId(user.uid);
        const adminCheck = checkIsAdmin(user, seller);
        
        if (isMounted) {
          setIsAdmin(adminCheck);
          setChecking(false);

          if (!adminCheck) {
            toast.error("Access denied. Admin privileges required.");
          }
        }
      } catch (err) {
        console.error("Admin verification error:", err);
        if (isMounted) {
          setIsAdmin(false);
          setChecking(false);
        }
      }
    };

    if (!authLoading) {
      verifyAdminStatus();
    }

    return () => {
      isMounted = false;
    };
  }, [user, authLoading]);

  if (authLoading || checking) {
    return <Loader fullScreen={true} />;
  }

  if (!user) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute;
